import PropTypes from 'prop-types';
import React from 'react';

import {ArchivableItem} from 'archive/ArchiveConstants';
import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import SettingsPageContainer from 'settings/SettingsPageContainer';
import licenses from 'user/Licenses';
import {capwords, typeToName} from 'util/NameUtil';

import SchemaSettingsExportDropdown from './SchemaSettingsExportDropdown';

interface SchemaSettingsPageContainerProps {
  children: React.ReactNode;
  onExportSpreadsheetTemplate?: () => void;
  onNavigateToListing: () => void;
  schema: ArchivableItem | null;
  schemaType: ModelTypeConstants;
}

/*
 * Container component for a schema page, where a user is either creating or editing a schema.
 */
export default function SchemaSettingsPageContainer(props: SchemaSettingsPageContainerProps): JSX.Element {
  return (
    <SettingsPageContainer
      onClickTitle={props.onNavigateToListing}
      subtitle={
        props.schema ? (
          <span>
            {props.schema.name}
            <ArchiveRecordLabel item={props.schema} />
          </span>
        ) : (
          ''
        )
      }
      title={`${capwords(typeToName(props.schemaType))}s`}
      toolbar={
        props.schema &&
        licenses.hasEnterprisePlan() && (
          <SchemaSettingsExportDropdown
            onExportSpreadsheetTemplate={props.onExportSpreadsheetTemplate}
            schemaId={props.schema.id}
            schemaType={props.schemaType}
          />
        )
      }
    >
      {props.children}
    </SettingsPageContainer>
  );
}

SchemaSettingsPageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  onExportSpreadsheetTemplate: PropTypes.func,
  onNavigateToListing: PropTypes.func.isRequired,
  // Include schema if editing, or null if creating.
  schema: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }),
  schemaType: PropTypes.oneOf(Object.values(ModelTypeConstants)).isRequired,
};
